export * from './english-iq-v2-result';
